import { VCryptoHashFunction, VDRM, VFinishEncryptRequest, VFinishEncryptResponse, VGPS, VGeoFencing, VSignature } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
import { dateToVDateTime } from '../utils/transforms';
class FinishEncryptionEndpoint extends EncryptedEndpoint {
    async getRequestInit({ allowCopy, allowForward, allowPrint, allowSave, authorizedUsers, biometricsRequired, countries, enableDecryptReceipts, fileId, fileName, hash, latitude, longitude, multifactorGeolocation, notesIncluded, secureFiles, sunriseDate, sunsetDate, totalSizeInBytes }) {
        const requestBytes = VFinishEncryptRequest.encode({
            allowForward,
            authorizedUsers,
            biometricsRequired,
            drm: VDRM.fromJSON({ allowCopy, allowPrint, allowSave }),
            enableDecryptReceipts,
            fileId,
            fileName,
            geoFencing: countries === undefined
                ? undefined
                : VGeoFencing.fromJSON({
                    countries,
                    territories: [],
                    cities: []
                }),
            gps: latitude !== undefined && longitude !== undefined
                ? VGPS.fromJSON({
                    latitude,
                    longitude
                })
                : VGPS.fromJSON({}),
            multifactorGeolocation,
            notesIncluded,
            secureFiles,
            sunriseDate: dateToVDateTime(sunriseDate),
            sunsetDate: dateToVDateTime(sunsetDate),
            signature: VSignature.decode(VSignature.encode({
                hash,
                function: VCryptoHashFunction.SHA_256
            }).finish()),
            totalSizeInBytes,
            require2FA: false,
            enableDataSharedAlert: false
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VFinishEncryptResponse.decode(responseBytes);
    }
}
export const finishEncryptionEndpoint = new FinishEncryptionEndpoint({
    path: '/encryptions',
    method: 'PUT',
    sideEffect: true,
    body: {},
    schema: VFinishEncryptResponse
});
